import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useCurrentMedia } from '@panneau/medias';
import MediaJobsList from '../../components/lists/MediaJobs';
import useMediaSocket from '../../hooks/useMediaSocket';
import { mediaJobs } from '../../lib/PropTypes';

const propTypes = {
    value: mediaJobs,
    className: PropTypes.string,
};

const defaultProps = {
    value: mediaJobs,
    className: null,
};

const MediaJobsField = ({ value, className }) => {
    const { currentMedia } = useCurrentMedia();
    const { id: mediaId, type: mediaType } = currentMedia;

    const [jobs, setJobs] = useState(value);
    useEffect(
        () => setJobs(value.jobs),
        [value]
    );

    const onMediaSocketMessage = ({ event, data: newMediaState }) => {
        if (event === 'medias.updated' && newMediaState.id === mediaId) {
            setJobs(newMediaState.jobs);
        }
    };
    useMediaSocket(mediaId, onMediaSocketMessage);

    return <div
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
    >
        <MediaJobsList value={jobs} mediaId={mediaId} mediaType={mediaType} />
    </div>
};

MediaJobsField.propTypes = propTypes;
MediaJobsField.defaultProps = defaultProps;

export default MediaJobsField;
